import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Scenarios", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add Scenario ")
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "resources-heading" }, "Conversation Resources", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" No records found. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.newScenariosMessage && !_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.newScenariosMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createVNode(_component_DataTable, {
      value: _ctx.scenarios,
      expandedRows: _ctx.expandedRows,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedRows) = $event)),
      dataKey: "id",
      "row-class": _ctx.handleRowClass
    }, {
      header: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "p-button",
          to: { name: _ctx.ScenarioAddRoute, params: { categoryId: _ctx.categoryId } }
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      expansion: _withCtx((slotProps) => [
        _hoisted_8,
        _createElementVNode("div", {
          innerHTML: slotProps.data.resources
        }, null, 8, _hoisted_9)
      ]),
      empty: _withCtx(() => [
        _hoisted_10
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "text",
          header: "Text",
          class: "scenario-text"
        }, {
          body: _withCtx((slotProps) => [
            (!_ctx.isAdmin && slotProps.data.newAddition)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 0,
                  value: "NEW",
                  severity: "success"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(slotProps.data.text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Actions",
          class: "actions-column"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "p-button",
                    to: _ctx.editRoute(slotProps.data.id)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!slotProps.data.enabled)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "p-button",
                          disabled: slotProps.data.loading,
                          onClick: ($event: any) => (_ctx.toggle(slotProps.data))
                        }, " Enable ", 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "p-button p-button-danger",
                          disabled: slotProps.data.loading,
                          onClick: ($event: any) => (_ctx.toggle(slotProps.data))
                        }, " Disable ", 8, _hoisted_6))
                  ], 64)),
              (slotProps.data.resources)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "p-button",
                    onClick: ($event: any) => (_ctx.toggleExpand(slotProps.data))
                  }, " Resources ", 8, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "row-class"])
  ], 64))
}